import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";
import Vuebar from "vuebar";
import toast from './toast.service'
import VueSkycons from "vue-skycons";
import VueMask from 'v-mask';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';
import VueClipboard from 'vue-clipboard2';
import axios from "axios";
// import { setupApiServices } from './api.service2';

// Global Mixin for Toast
Vue.mixin(toast);

// Other Plugins
Vue.use(VueSkycons, { color: "#1e88e5" });
Vue.use(VueMask);
Vue.use(Vuebar);
Vue.use(VuetifyDraggableTreeview);
Vue.use(VueClipboard);

// Bus for event communication
const bus = new Vue();
Vue.prototype.$bus = bus;

// Vue config
Vue.config.productionTip = false;

// Error clearing method
Vue.mixin({
	methods: {
		clearError(field) {
			if (this.form[field] === '' || this.form[field] === null || this.form[field] === undefined) {
				this.$delete(this.errors, field);
			} else {
				this.$set(this.errors, field, '');
			}
		}
	}
});

// Load the config file first, then initialize the app
axios.get('/config.json', {baseURL: process.env.BASE_URL})
	.then(async ({data: config}) => {
		
		// Store the config globally
		window.APP_CONFIG = config;
		// console.log("Loaded config:", window.APP_CONFIG);

		// Initialize API services after config is loaded
		// await setupApiServices();

		// Dispatch authentication attempt
		store.dispatch('attempt', localStorage.getItem('id_token'))
			.then(() => {
				// Create Vue app after authentication attempt
				new Vue({
					vuetify,
					store,
					router,
					render: (h) => h(App),
				}).$mount("#app");
			})
			.catch(() => {
				// Fallback Vue app creation if authentication fails
				new Vue({
					vuetify,
					store,
					router,
					render: (h) => h(App),
				}).$mount('#app');
			});
	})
	.catch(error => {
		// Handle error in loading config.json
		console.error("Failed to load config.json", error);
	});
